import { useEffect } from 'react';
import useRequestEmailVerification from 'components/Hooks/useRequestEmailVerification';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { makeSelectAuth, makeSelectAuthModal } from 'containers/Auth/selectors';
import useIsEmailVerified from 'components/Hooks/useIsEmailVerified';
import useIsAuthPath from 'components/Hooks/useIsAuthPath';
import { showVerificationModal } from 'containers/Auth/actions';
import { isSignUpPeriod } from 'utils/authUtils';

function useAccountVerification() {
  const location = useLocation();
  const auth = useSelector(makeSelectAuth());
  const { needsVerification } = useIsEmailVerified();
  const isAuthenticationPage = useIsAuthPath();
  const requestEmailVerification = useRequestEmailVerification();
  const modal = useSelector(makeSelectAuthModal());
  const dispatch = useDispatch();

  useEffect(() => {
    const token =
      auth &&
      auth.isLoaded &&
      !auth.isEmpty &&
      _get(auth, 'stsTokenManager.accessToken');

    if (needsVerification && !isAuthenticationPage && token) {
      // If modal is open, show verification modal
      if (modal && modal?.show) {
        dispatch(
          showVerificationModal({
            show: true,
            payload: {
              token,
              type: 'MODAL_SIGNUP',
            },
            info: {
              isSignUp: isSignUpPeriod(auth),
              showSuccessModal: true,
            },
          }),
        );
        return;
      }
      // Pass current location as redirect so user returns to this page after verification
      requestEmailVerification(location.pathname + location.search);
    }
  }, [
    requestEmailVerification,
    isAuthenticationPage,
    needsVerification,
    auth,
    location,
    modal,
  ]);
}

export default useAccountVerification;
